module.exports = __webpack_public_path__ + "app/assets/images/warning.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/warning.png
// module id = 298
// module chunks = 7